

exports.__esModule = true;
exports.$xoSidebarCurrencyConversionPageComponent = undefined;

var _uiRouter = require('uiRouter');

var _squid = require('squid');

require('xo-page-components/src/aside-header/directive');

require('xo-wallet-components/src/currency-conversion/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarCurrencyConversionPageComponent = exports.$xoSidebarCurrencyConversionPageComponent = _squid.$Component.extend('$xoSidebarCurrencyConversionPageComponent', {
    tag: 'xo-sidebar-currency-conversion-page',
    template: _template2['default'],
    controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
        $scope.token = $rootScope.token;

        $scope.onComplete = function (checkoutSession) {
            if (checkoutSession) {
                $rootScope.$broadcast('reloadCheckoutSession', { checkoutSession: checkoutSession });
            }
            _uiRouter.$state.go('checkout.review');
        };
        $scope.$emit('populated');
    }]
});

angular.value("$xoSidebarCurrencyConversionPageComponent", $xoSidebarCurrencyConversionPageComponent);
_uiRouter.$state;

_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-currency-conversion/directive.js
// module id = ./pages/xo-sidebar-currency-conversion/directive.js
// module chunks = 0